import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import Checkbox from "@mui/material/Checkbox";
import { Typography } from "@mui/material";
import { ShiftEffectiveDateLogic } from "../../models/calculation/TESCalculationParameters";
import MuiSelect from "../framework/muiSelect";
import { NumberInput } from "../framework/numberInput";
import { CalcGeneralProps } from "./CalculationMain";
import { Alert } from "@mui/material";

export const CalcShiftSettings = ({
    translate,
    handleChange,
    settings,
}: CalcGeneralProps) => {
    const {
        paidBreak,
        paidBreakShiftMinMinutes,
        paidWaiting,
        shiftEffectiveDateLogic,
        isWorkShiftStartBasedOnPlannedShift,
    } = settings || {};

    return (
        <Grid2 container direction="column" p={3} spacing={2}>
            <Grid2>
                <Typography variant="h3">{translate("workShifts")}</Typography>
            </Grid2>
            <Grid2>
                <NumberInput
                    id="paidBreak"
                    value={paidBreak}
                    className="field-width-normal"
                    label={translate("paidBreak")}
                    onChange={(val) => handleChange("paidBreak", val)}
                    endAdornment="min"
                />
            </Grid2>
            {paidBreak > 0 ? (
                <Grid2 sx={{ pl: 6 }}>
                    <NumberInput
                        id="paidBreakShiftMinMinutes"
                        value={paidBreakShiftMinMinutes}
                        label={translate("paidBreakShiftMinMinutes")}
                        onChange={(val) =>
                            handleChange("paidBreakShiftMinMinutes", val)
                        }
                        endAdornment="min"
                        fullWidth
                    />
                </Grid2>
            ) : null}
            <Grid2>
                <NumberInput
                    id="paidWaiting"
                    value={paidWaiting}
                    className="field-width-normal"
                    label={translate("paidWaiting")}
                    onChange={(val) => handleChange("paidWaiting", val)}
                    endAdornment="min"
                />
            </Grid2>
            <Grid2>
                <MuiSelect
                    label={translate("shiftEffectiveDateLabel")}
                    className="field-width-normal"
                    value={shiftEffectiveDateLogic}
                    onChange={(val) =>
                        handleChange("shiftEffectiveDateLogic", val)
                    }
                    options={Object.keys(ShiftEffectiveDateLogic)
                        .filter((key) => isNaN(parseInt(key)))
                        .map((key) => ({
                            value: ShiftEffectiveDateLogic[key],
                            label: translate(`shiftEffectiveDateOption.${key}`),
                        }))}
                />
            </Grid2>
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        id="isWorkShiftStartBasedOnPlannedShift"
                        checked={isWorkShiftStartBasedOnPlannedShift}
                        onChange={(event) =>
                            handleChange(
                                "isWorkShiftStartBasedOnPlannedShift",
                                event.target.checked
                            )
                        }
                    />
                    {translate("isWorkShiftStartBasedOnPlannedShift")}
                </label>
                <Grid2>
                    <Alert severity="info" className="field-width-normal">
                        {translate("isWorkShiftStartBasedOnPlannedShiftDescription")}
                    </Alert>
                </Grid2>
            </Grid2>
        </Grid2>
    );
};
